/**
 * @file   src/components/AiChat/AiChatMessage.js
 * @brief  Individual chat message bubble (AI or user)
 * @date   February, 2026
 * @author Jake Hokinson
 */
import React from "react";

const AiChatMessage = ({ message, children }) => {
  const isUser = message.role === "user";

  return (
    <div className={`ai-chat-message ${isUser ? "user-message" : "ai-message"}`}>
      <div className="ai-message-avatar">
        {isUser ? "👤" : "✨"}
      </div>
      <div className="ai-message-bubble">
        {message.content}
        {children}
      </div>
    </div>
  );
};

export default AiChatMessage;
